<template>
    <div class="lastUsedColors">
        <strong>{{ $t('editorSceneElementOptionsLastUsedColors') }}</strong>
        <div>
            <span
                v-for="(color, index) in getLastUsedColors"
                :key="`lastUsed_${index}`"
                :style="`background-color: #${color.hex}`"
                @click="changeElementColor(color)"
            />
            <span
                v-for="index in (5 - getLastUsedColors.length)"
                :key="`lastUsedEmpty_${index}`"
                class="lastUsedEmpty"
            />
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { qrSvg } from '../../../js/qrCodeSvg';

    export default {
        methods: {
            changeElementColor(color) {
                if (this.getActiveElement.type === 'QR_CODE_ELEMENT') {
                    const payload = {
                        side: this.qrColorSide,
                        color: {
                            rgb: color.rgb,
                            hex: color.hex,
                            x: color.x,
                            y: color.y
                        }
                    };

                    this.$store.dispatch('QR_ELEMENT_COLOR', payload);

                    const colors = this.qrColorSide === 'frontColor' ? { f: payload.color, b: this.getActiveElement.backColor } : { f: this.getActiveElement.frontColor, b: payload.color };

                    qrSvg(this.getActiveElement.content, colors.f, colors.b, this.getActiveElement.width, this.getActiveElement.id);
                    
                } else {
                    this.$store.dispatch('ELEMENT_COLOR', {
                        rgb: color.rgb,
                        hex: color.hex,
                        x: color.x,
                        y: color.y
                    });
                }                
            }
        },
        computed: {
            ...mapGetters([
                'getLastUsedColors',
                'getActiveElement'
            ])
        },
        props: ['qrColorSide']
    }
</script>

<style lang="scss" scoped>
    .lastUsedColors {
        width: 150px;
        margin: 15px auto;

        > div {
            display: grid;
            grid-template-columns: repeat(5, 1fr);
            grid-gap: 10px;
            margin-top: 10px;
        }
        span {
            display: block;
            width: 100%;
            padding-top: 100%;
            border-radius: 3px;
            background-color: #EFEFEF;
            border: 1px solid #D4D4D4;
            box-sizing: border-box;
            cursor: pointer;

            &.lastUsedEmpty {
                cursor: unset;
            }
        }
    }
</style>